import { Components, radioClasses, Theme } from '@mui/material';

import { RadioButtonIcon, radioButtonIconClasses } from '@controls/icons/RadioButtonIcon';

type MuiRadioTheme = Components<Theme>['MuiRadio'];

export const muiRadioTheme: MuiRadioTheme = {
  defaultProps: {
    icon: <RadioButtonIcon />,
    checkedIcon: <RadioButtonIcon checked={true} />,
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      [`& .${radioButtonIconClasses.border}`]: {
        transition: theme.transitions.create(['fill', 'stroke'], {
          easing: theme.transitions.easing.easeIn,
          duration: theme.transitions.duration.shortest,
        }),
        fill: '#fff',
        stroke: theme.palette.grey[400],
      },
      [`& .${radioButtonIconClasses.dot}`]: {
        fill: theme.palette[ownerState.color === 'default' ? 'primary' : (ownerState.color ?? 'primary')].main,
      },
      [`&.${radioClasses.disabled}`]: {
        cursor: 'default',
        [`& .${radioButtonIconClasses.border}`]: {
          fill: '#fff',
          stroke: theme.palette.action.disabled,
        },
        [`& .${radioButtonIconClasses.dot}`]: {
          fill: theme.palette.action.disabled,
        },
      },
      [`&:hover:not(.${radioClasses.disabled})`]: {
        backgroundColor: 'transparent',
        [`& .${radioButtonIconClasses.border}`]: {
          fill: theme.palette[ownerState.color === 'default' ? 'primary' : (ownerState.color ?? 'primary')].light,
          stroke: theme.palette[ownerState.color === 'default' ? 'primary' : (ownerState.color ?? 'primary')].main,
        },
        [`& .${radioButtonIconClasses.dot}`]: {
          fill: theme.palette[ownerState.color === 'default' ? 'primary' : (ownerState.color ?? 'primary')].dark,
        },
      },
    }),
  },
};
